// SPDX-FileCopyrightText: 2012-2026 Open Assessment Technologies S.A.
// Copyright (C) 2024 (original work) Open Assessment Technologies SA
//
// SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-TAO-Commercial-License

import { user as currentUserStore } from '@/stores/auth.store';
import { get } from 'svelte/store';
import config from '@/config';

/**
 * @type Guard
 */
export const loginGuard = async (next, router) => {
    await currentUserStore.updateTokenData();
    const user = get(currentUserStore);
    if (!user) {
        return next();
    }

    router.redirect(config.routes.home);
};
